<template>
  <div><PageTable /></div>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'appManager-pad-version-management',
  components: { PageTable },
}
</script>
